export default [
  {
    // 社会
    cid: 2,
    label: 'Xã hội'
  },
  {
    // 娱乐
    cid: 3,
    label: 'Giải trí'
  },
  {
    // 国际
    cid: 4,
    label: 'Thế giới'
  },
  {
    // 运动
    cid: 5,
    label: 'Thể thao'
  },
  {
    // 经济
    cid: 6,
    label: 'Kinh tế'
  },
  {
    // 科技
    cid: 7,
    label: 'Công nghệ'
  },
  {
    // 法律
    cid: 9,
    label: 'Pháp luật'
  },
  {
    // 健康
    cid: 12,
    label: 'Sức khỏe'
  },
  {
    // 汽车
    cid: 14,
    label: 'Xe cộ'
  },
  {
    cid: 13,
    label: 'Ẩm thực'
  },
  {
    cid: 18,
    label: 'Tình yêu'
  },
  {
    cid: 19,
    label: 'Đời sống'
  },
  {
    cid: 21,
    label: 'Giáo dục'
  },
  {
    cid: 11,
    label: 'Game'
  },
  {
    cid: 23,
    label: 'Bóng đá'
  },
  {
    cid: 10,
    label: 'Du lịch'
  },
  {
    cid: 8,
    label: 'Thời trang'
  },
  {
    cid: 15,
    label: 'Góc hài'
  },
  {
    cid: 22,
    label: 'Hotgirl'
  },
  {
    cid: 24,
    label: 'Làm đẹp'
  },
  {
    cid: 25,
    label: 'Video'
  }
// Làm đẹp （化妆）
// Tình yêu （爱情）
// Giáo dục （教育）
// Đời sống （生活）
// Ẩm thực (食物)
// Game (游戏)
// Du lịch （旅游）
// Thời trang (时尚)
// Bóng đá （足球）
// Video
// Góc hài （喜剧角）
// Hotgirl
// 13: 美食;
// 18: 爱情;
// 19: 生活;
// 21: 教育;
// 11: 游戏;
// 23: 足球;
// 10: 旅游;
// 8: 时尚;
// 1: 视频;
// 15: 搞笑;
// 22: 美女;
// 24: 美容;
]



// WEBPACK FOOTER //
// ./src/assets/cids.js